export default __webpack_public_path__ + "static/media/brc.1db3f0de.pdf";